<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">Adatkezelési és adatvédelmi szabályzat</h1>
        <p class="mb-8"><strong>Hatályos: 2025.07.16-tól</strong></p>
        <p class="mb-4"><strong>1. A Szabályzat célja</strong></p>
        <p class="mb-4"><strong>1.1. Bevezetés</strong></p>
        <p class="mb-4">A jelen Adatkezelési és Adatvédelmi Szabályzat (a továbbiakban: Szabályzat) célja, hogy az
            Adatkezelő a https://pipacspekseg.hu/pipacs/ megnevezésű internetes oldalának látogatói (a továbbiakban:
            Érintettek) számára biztosítsa jogaik és törvényes érdekeinek védelmét az Adatkezelő webes adatkezelései
            során, valamint elősegítse a webes és egyéb adatkezelések során az adatbiztonság érvényesülését.</p>
        <p class="mb-4">Az Adatkezelő webes adatkezeléseit érintő adatkezelésekkel kapcsolatos adatvédelmi
            rendelkezéseket, és az Adatkezelési Szabályzatot a https://pipacspekseg.hu/pipacs/ honlapon tette
            elérhetővé.</p>
        <p class="mb-4"><strong>1.2. Általános rendelkezések</strong></p>
        <p class="mb-4">Adatkezelő az Érintettek joggyakorlását a jelen Szabályzatban foglaltak szerint biztosítja,
            azzal, hogy az itt felsorolt adatkezelései során az Érintettek jogainak tiszteletben tartása mellett jár
            el.</p>
        <p class="mb-4"><strong>1.3. Adatkezelő a Szabályzat változtatására a jogot fenntartja.</strong></p>
        <p class="mb-4">A jelen Szabályzat módosítására különösen akkor kerülhet sor, ha új adatkezelés szükségessége
            merül fel, jogszabályváltozás, hatósági gyakorlat változása, új biztonsági kockázat, vagy az érintettek
            visszajelzése alapján indokolt.</p>
        <p class="mb-4">A módosítások, változtatások az Adatkezelő https://pipacspekseg.hu/pipacs/ honlapján érhetők
            el.</p>
        <p class="mb-4"><strong>2. A Szabályzat hatálya</strong></p>
        <p class="mb-4">A webes adatkezelések során Irányadó jogszabályok, többek között:</p>
        <ul class="mb-4">
            <li>az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvény
                (továbbiakban: „Infotv.”)
            </li>
            <li>a gazdasági reklámtevékenység alapvető feltételeiről és egyes korlátairól szóló 2008. évi XLVIII.
                törvény (továbbiakban: „Grtv.”);
            </li>
            <li>az információs társadalommal összefüggő szolgáltatások egyes kérdéseiről szóló 2001. évi CVIII. törvény
                (a továbbiakban: Eker tv.)
            </li>
            <li>az Európai Parlament és a Tanács 2016/679 Rendelete (a továbbiakban: „GDPR”);</li>
            <li>az elektronikus kereskedelmi szolgáltatások, valamint az információs társadalommal összefüggő
                szolgáltatások egyes kérdéseiről szóló 2001. évi CVIII. törvény;
            </li>
            <li>a számvitelről szóló 2000. évi C. törvény 169. § (a bizonylatok megőrzése).</li>
        </ul>
        <p class="mb-4">A Szabályzat tárgyi hatálya kiterjed az alábbi webes adatkezelési formákra:</p>
        <ul class="mb-4">
            <li>kapcsolatfelvétel, érdeklődés</li>
            <li>panasz, egyéb jogi igény előterjesztése</li>
            <li>sütikezelés</li>
            <li>hírlevélre feliratkozás</li>
            <li>Pmt. szerinti adatkezelés (ügyfélazonosítás, kiemelt közszereplői minőség vizsgálata, tényleges
                tulajdonosi struktúra).
            </li>
        </ul>
        <p class="mb-4">A Szabályzat tárgyi hatálya kiterjed minden, az Adatkezelő által végzett adatkezelési műveletre,
            így vonatkozik az elektronikus és papír alapon végzett adatkezelésekre egyaránt.</p>
        <p class="mb-4">A Szabályzat időbeli hatálya 2025.07.16-tól visszavonásig.</p>
        <p class="mb-4">A Szabályzat személyi hatálya kiterjed:</p>
        <ul class="mb-4">
            <li>az Adatkezelőre</li>
            <li>az Adatkezelő ügyfeleire,</li>
            <li>az Adatkezelő munkavállalóira,</li>
            <li>az Adatkezelővel szerződéses kapcsolatban lévő természetes és jogi személyekre, vagy jogi személyiség
                nélküli szervezetekre,
            </li>
            <li>azon Érintettekre, akikre vonatkozóan a jelen Szabályzat rendelkezést tartalmaz</li>
            <li>azon Érintettekre, akiknek jogát vagy jogos érdekét a jelen Szabályzat szerinti adatkezelés érinti,</li>
            <li>az Adatkezelő honlapjának látogatóira,</li>
            <li>illetve mindazokra, akik a honlapon keresztül kérdést, érdeklődést intéztek az Adatkezelő
                szolgáltatásaival összefüggésben.
            </li>
        </ul>
        <p class="mb-4"><strong>3. Az Adatkezelő</strong></p>
        <p class="mb-4"><strong>3.1. Az Adatkezelő</strong></p>
        <p class="mb-4">Az a természetes, vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely
            a személyes adatok kezelésének céljait és eszközeit önállóan vagy másokkal együtt meghatározza; ha az
            adatkezelés céljait és eszközeit az uniós vagy a tagállami jog határozza meg, az adatkezelőt vagy az
            adatkezelő kijelölésére vonatkozó különös szempontokat az uniós vagy a tagállami jog is meghatározhatja.</p>
        <p class="mb-4"><strong>3.2. ADATVÉDELMI TISZTVISELŐ kinevezésére nem kötelezett.
        </strong></p>
        <table class="mx-auto">
            <tbody>
                <tr>
                    <td class="pr-4">Név:</td>
                    <td>Pipacs Pékség Kft.</td>
                </tr>
                <tr>
                    <td class="pr-4">Székhely:</td>
                    <td>1033 Budapest, Szentendrei út 95.</td>
                </tr>
                <tr>
                    <td class="pr-4">Kapcsolati adatok:</td>
                    <td>info@pipacspekseg.hu</td>
                </tr>
                <tr>
                    <td class="pr-4">Cégjegyzékszám:</td>
                    <td>01-09-305671</td>
                </tr>
                <tr>
                    <td class="pr-4">Adószám:</td>
                    <td>26169718-2-41</td>
                </tr>
                <tr>
                    <td class="pr-4">Nyilvántartásba vételt elrendelő hatóság</td>
                    <td>Fővárosi Törvényszék Cégbírósága</td>
                </tr>
            </tbody>
        </table>
        <p class="mb-4"><strong>4. Adattovábbítás és adatfeldolgozók</strong></p>
        <p class="mb-4"><strong>4.1. Az általunk gyűjtött adatokat csak akkor továbbítjuk, ha:</strong></p>
        <ul class="mb-4">
            <li>Ön a GDPR 6. cikk (1) bekezdés a) szerint kifejezett hozzájárulását adta, vagy</li>
            <li>a közzététel a GDPR 6. cikk (1) bekezdés 1. mondatának 1. f) pontja szerinti jogi igények
                érvényesítéséhez, gyakorlásához vagy védelméhez szükséges, és nincs okunk feltételezni, hogy az Ön jogai
                , vagy
            </li>
            <li>a GDPR 6. cikk (1) bekezdés 1. pontjának c) alpontja alapján törvényi kötelezettségünk van az Ön
                adatainak közlésére, vagy
            </li>
            <li>ez jogilag megengedett és szükséges a GDPR 6. cikk (1) bekezdés 1. pontjának b) alpontja szerint az
                Önnel fennálló szerződés teljesítéséhez vagy az Ön kérésére történő szerződéskötést megelőző
                intézkedések végrehajtásához.
            </li>
        </ul>
        <p class="mb-4">„adatfeldolgozó”: az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely
            egyéb szerv, amely az adatkezelő nevében személyes adatokat kezel.</p>
        <p class="mb-4">Social media felületek:</p>
        <ul class="mb-4">
            <li>Facebook https://www.facebook.com/</li>
            <li>Instagram https://www.instagram.com/</li>
            <li>YouTube https://www.youtube.com/</li>
            <li>Linkedin https://hu.linkedin.com/</li>
            <li>TikTok https://www.tiktok.com/hu-HU/</li>
        </ul>
        <p class="mb-4">Adatfeldolgozók adatai:</p>
        <table class="mx-auto">
            <tbody>
                <tr>
                    <td class="pr-4">Név:<br/>Elérhetőség:<br/>Tevékenység:</td>
                    <td>RackForest<br/>https://rackforest.com/<br/>Tárhelyszolgáltató</td>
                </tr>
                <tr>
                    <td class="pr-4">Név:<br/>Elérhetőség:<br/>Tevékenység:</td>
                    <td>C4WEB STUDIO SRL<br/>300667, Timisoara, Cl.Torontalului 25/A<br/>Webfejlesztő</td>
                </tr>
                <tr>
                    <td class="pr-4">Név:<br/>Elérhetőség:<br/>Tevékenység:</td>
                    <td>Gmail<br/>https://mail.google.com/<br/>Levelezési rendszer</td>
                </tr>
                <tr>
                    <td class="pr-4">Név:<br/>Elérhetőség:<br/>Tevékenység:</td>
                    <td>Sweet & Conto Balance Kft<br/>1221 Budapest Szentkorona utca 11<br/>Könyvelés</td>
                </tr>
                <tr>
                    <td class="pr-4">Név:<br/>Elérhetőség:<br/>Tevékenység:</td>
                    <td>Számlázz.hu<br/>https://www.szamlazz.hu/ <br/>Számlázás</td>
                </tr>
                <tr>
                    <td class="pr-4">Név:<br/>Elérhetőség:<br/>Tevékenység:</td>
                    <td>OTP Simple Pay<br/>https://simplepay.hu/ <br/>Fizetési rendszer</td>
                </tr>
                <tr>
                    <td class="pr-4">Név:<br/>Elérhetőség:<br/>Tevékenység:</td>
                    <td>Akamai Technologies International AG<br/>Switzerland Zug CH-6300 Grafenauweg 8<br/>Tárhely
                        szolgáltató
                    </td>
                </tr>
            </tbody>
        </table>
        <p class="mb-4">Az adatfeldolgozás egy részét szolgáltatóink végzik. A jelen adatvédelmi szabályzatban említett
            szolgáltatókon kívül ide tartozhatnak különösen a weboldalunkat, adatbázisainkat és alkalmazásainkat
            hosztoló adatközpontok, a megfelelő alkalmazásokat számunkra biztosító és továbbfejlesztő
            szoftverszolgáltatók, a rendszereinket karbantartó informatikai szolgáltatók, ügynökségek, piackutató cégek,
            csoportvállalatok, fizetési szolgáltatók, hírlevél-küldők, logisztikai szolgáltatók és tanácsadó cégek.</p>
        <p class="mb-4">Adatfeldolgozóink változtatásának jogát fenntartjuk és az alvállalkozói körünkbe tartozó
            beszállítók nyilvántartását Adatkezelő jogos érdeke alapján zártan kezeljük, a velünk szerződő partnerek
            listáját belső üzleti titokként kezeljük. Ha bővebb tájékoztatást szeretne kapni az ide vonatkozó
            érdekmérlegelésről, kérjük vegye fel a kapcsolatot az alábbi e-mail címen: info@pipacspekseg.hu</p>
        <p class="mb-4">Adatkezelő csak olyan adatfeldolgozókat vesz igénybe, akik megfelelő garanciákat nyújtanak az
            érintettek jogainak védelmére és megfelelő technikai és szervezési intézkedéseket hoznak létre annak
            érdekében, hogy maximálisan megfeleljenek az adatvédelmi előírásoknak, ennek érdekében adatvédelmi
            szerződésekben garantálják az együttműködésük kereteit, mely alapján Adatkezelő biztosítja, hogy személyes
            adatokat kizárólag az adatkezelő írásbeli utasításai alapján kezeli, illetve, hogy a személyes adatok
            kezelésére feljogosított személyek titoktartási kötelezettséget vállalnak, valamint megfelelő technikai és
            szervezési intézkedésekkel a lehetséges mértékben segíti az adatkezelőt abban, hogy teljesíteni tudja
            kötelezettségét. Ily módon az adatfeldolgozás nem eredményezheti az adatokkal történő visszaélést, nem
            valósíthat meg jogellenes magatartást és nem járhat az érintetti jogok sérelmével.</p>
        <p class="mb-4"><strong>4.2. Online jelenlét a közösségi hálózatokban</strong></p>
        <p class="mb-4">A közösségi média felületeken jelen vagyunk, hogy ott kommunikáljunk többek között az
            ügyfelekkel és az érdeklődőkkel, és tájékoztassuk őket termékeinkről, szolgáltatásainkról, akcióinkról.</p>
        <p class="mb-4">A felhasználói adatokat az érintett közösségi hálózatok általában piackutatási és reklám
            célokból dolgozzák fel. Ily módon a felhasználók érdeklődési köre alapján használati profilok hozhatók
            létre. Ebből a célból sütiket és egyéb azonosítókat tárolnak a felhasználók számítógépén. Ezen használati
            profilok alapján különböző hirdetéseket jelenítenek meg a látogatók számára személyes preferenciájuk és
            érdeklődési körük alapján.</p>
        <p class="mb-4">Online jelenléteink működtetésének részeként lehetséges, hogy hozzáférhetünk olyan
            információkhoz, mint például az online jelenléteink használatára vonatkozó statisztikák, amelyeket a
            közösségi hálózatok szolgáltatnak. Ezek a statisztikák összesítettek, és tartalmazhatnak különösen
            demográfiai információkat, valamint az online jelenléteinkkel és az azokon keresztül terjesztett
            bejegyzésekkel és tartalmakkal kapcsolatos interakciókra vonatkozó adatokat.</p>
        <p class="mb-4">Az adatkezelés jogalapja a GDPR 6. cikk (1) bekezdés f) pontja, amely a felhasználók hatékony
            tájékoztatásához és a felhasználókkal való kommunikációhoz fűződő jogos érdekünkön alapul, annak érdekében,
            hogy kapcsolatban maradjunk ügyfeleinkkel és tájékoztassuk őket.</p>
        <p class="mb-4">Az alábbi linkek további információt nyújtanak az adott adatkezelésről és az érintetti jogok
            gyakorlásának módjáról.</p>
        <p class="mb-4"><strong>5. Az adatkezelés célja és jogalapja</strong></p>
        <p class="mb-4">Az Adatkezelő az alábbi személyes adatok kezelését az alábbi jogalapokon végzi:</p>
        <p class="mb-4">személyes adat: azonosított vagy azonosítható természetes személyre („érintett”) vonatkozó
            bármely információ. </p>
        <table class="mb-4 w-full">
            <tbody>
                <tr>
                    <td><strong>AK JELLEGE</strong></td>
                    <td><strong>KEZELT ADATOK</strong></td>
                    <td><strong>AK CÉLJA</strong></td>
                    <td><strong>AK JOGALAP</strong></td>
                    <td><strong>MEGŐRZÉSI IDŐ</strong></td>
                    <td><strong>ÉRINTETTEK/CÍMZETTEK</strong></td>
                </tr>
                <tr>
                    <td>Kapcsolatfelvétel weboldalon keresztül<br/>Ajánlat kérés</td>
                    <td>Név, e-mail cím, telefonszám, üzenet szövege</td>
                    <td>Ügyfél érdeklődések megkeresések kezelése és nyilvántartása</td>
                    <td>GDPR 6. cikk (1) bekezdés a) pont szerinti hozzájárulás</td>
                    <td>A hozzájárulás visszavonásáig, illetve az érdeklődésre adott válasz érintett részére történő
                        megküldéséig
                    </td>
                    <td>A kapcsolattartásra felhatalmazott személyek</td>
                </tr>
                <tr>
                    <td>Élelmiszer-kiskereskedelem, vendéglátás és oktatási jellegű szolgáltatás</td>
                    <td>Szerződéskötéshez szükséges adatok: vezetéknév, keresztnév, lakcím, e-mail, telefonszám;
                        Számlázáshoz szükséges adatok: cégnév, székhely, cégjegyzékszám, adószám, e-mail cím
                    </td>
                    <td>szolgáltatás igénybevétele</td>
                    <td>GDPR 6. cikk (1) bekezdés b) pont szerinti szerződés teljesítése</td>
                    <td>Szolgáltatás teljesítését, illetve a szerződés megszűnését követő 5 év</td>
                    <td>Az ügyfelekkel való kapcsolattartásra felhatalmazott személyek</td>
                </tr>
                <tr>
                    <td>Panasz, jogi igény érvényesítése</td>
                    <td>Név, e-mail cím, v lakcím (opcionális), telefonszám (opcionális)</td>
                    <td>Panasz, jogi igény sikeres elbírálása</td>
                    <td>GDPR 6 cikk (1) bekezdés c) pont szerinti jogi kötelezettség</td>
                    <td>Panasz, jogi igény sikeres orvoslása, illetve jogi igényérvényesítés esetén a Fgytv. szerint tárgyév
                        + 5 év
                    </td>
                    <td>Panasz elbírálásában részt vevő személyek</td>
                </tr>
                <tr>
                    <td>Sütikezelés</td>
                    <td>Felhasználó azonosítására alkalmas adatot nem tartalmaznak</td>
                    <td>Személyre szabott tartalom, felhasználói élmény javítása</td>
                    <td>GDPR 6. cikk (1) bek. a) pont szerinti hozzájárulás</td>
                    <td>Böngészőben történő törlésig</td>
                    <td>Honlap üzemeltetője, illetve harmadik fél</td>
                </tr>
                <tr>
                    <td>Sütikezelés</td>
                    <td>Felhasználó azonosítására alkalmas adatot nem tartalmaznak (elengedhetetlen sütik)</td>
                    <td>Weblap működéséhez elengedhetetlenül szükséges</td>
                    <td>GDPR 6. cikk (1) bek. f) pont szerinti adatkezelői jogos érdek</td>
                    <td>Böngészőben történő törlésig</td>
                    <td>Honlap üzemeltetője, illetve harmadik fél</td>
                </tr>
                <tr>
                    <td>Számviteli bizonylatok</td>
                    <td>Szolgáltatás igénybe vevőjének neve + címe</td>
                    <td>Számla-és bizonylat megőrzési kötelezettség teljesítése</td>
                    <td>GDPR 6. cikk (1) bek. c) pontja szerinti jogi kötelezettség</td>
                    <td>8 év</td>
                    <td>Bizonylatok kezelésével megbízott személy</td>
                </tr>
                <tr>
                    <td>Hírlevélre feliratkozás</td>
                    <td>Név, e-mail cím</td>
                    <td>Reklámanyag hírlevél formájában történő megküldése</td>
                    <td>GDPR 6. cikk (1) bek. a) pontja szerinti hozzájárulás</td>
                    <td>Hozzájárulás visszavonásáig vagy törlési kérelem benyújtásáig</td>
                    <td>A reklámanyagok kezelésével megbízott személy</td>
                </tr>
                <tr>
                    <td>Esemény létrehozása</td>
                    <td>Név, email-cím</td>
                    <td>Workshop, oktatás, tréning</td>
                    <td>GDPR 6. cikk (1) bek. a) pontja szerinti adatkezelői hozzájárulás</td>
                    <td>Hozzájárulás visszavonásáig vagy törlési kérelem benyújtásáig</td>
                    <td>Honlap üzemeltetője, illetve harmadik fél</td>
                </tr>
            </tbody>
        </table>
        <p class="mb-4"><strong>5.1. Az adatkezelés elvei</strong></p>
        <p class="mb-4">Adatkezelő az adatkezelései során kötelező érvényűen elfogadja és védi az általános adatvédelmi
            rendelet 5. cikke szerinti adatkezelési elveket, melyek az alábbiak:</p>
        <p class="mb-4">A személyes adatok kezelését jogszerűen és tisztességesen, valamint az érintett számára
            átlátható módon kell végezni („jogszerűség, tisztességes eljárás és átláthatóság”);</p>
        <p class="mb-4">A személyes adatok gyűjtése csak meghatározott, egyértelmű és jogszerű célból történhet, és azok
            nem kezelhetők a célokkal össze nem egyeztethető módon; („célhoz kötöttség”);</p>
        <p class="mb-4">Az adatkezelésnek céljai szempontjából megfelelőnek és relevánsnak kell lenni és a szükségesre
            kell, hogy korlátozódjon („adattakarékosság”);</p>
        <p class="mb-4">A kezelt személyes adatoknak pontosnak és szükség esetén naprakésznek kell lenniük; minden
            észszerű intézkedést meg kell tenni annak érdekében, hogy az adatkezelés céljai szempontjából pontatlan
            személyes adatok haladéktalanul törlésre vagy helyesbítésre kerüljenek („pontosság”);</p>
        <p class="mb-4">A személyes adatok tárolásának olyan formában kell történnie, amely az érintettek azonosítását
            csak a cél eléréshez szükséges ideig teszi lehetővé, figyelemmel a technikai és szervezési intézkedésekre is
            („korlátozott tárolhatóság”);</p>
        <p class="mb-4">A személyes adatok kezelését olyan módon kell végezni, hogy az adatok biztonsága technikai és
            szervezési intézkedések révén biztosítva legyen, az adatok jogosulatlan vagy jogellenes kezelésével,
            véletlen elvesztésével, megsemmisítésével vagy károsodásával szembeni védelmet is ideértve („integritás és
            bizalmas jelleg”).</p>
        <p class="mb-4">Adatfeldolgozóként igénybe vett partneri együttműködések kapcsán az Adatkezelő az Adatfeldolgozó
            tekintetében is irányadónak tekinti az ezen cikk szerinti adatkezelési elveket a feldolgozásra átadott
            adatok tekintetében. Adatkezelő a kezelt személyes adatokat ily módon felelősséggel és különös gondossággal
            őrzi. Adatkezelő belső nyilvántartást vezet a személyes adatok kezeléséről.</p>
        <p class="mb-4"><strong>6. Automatizált döntéshozatal alkalmazhatóságának feltételei</strong></p>
        <p class="mb-4">Az automatizált döntéshozatal célja az Adatkezelő egyes tevékenységei során a folyamatok
            optimalizálása, felgyorsítása, és új lehetőségek biztosítása annak érdekében, hogy az érdeklődő ügyfelek a
            lehető legjobb megoldási javaslatot vagy diagnózist kaphassák vagy a lehető legjobb kiszolgálásban
            részesülhessenek. Az automatizált döntéshozatal eredményét az Adatkezelő munkatársai ellenőrzik. Az érintett
            jogosult az automatizált döntéshozatallal kapcsolatban az adatkezelő részéről emberi beavatkozást kérni,
            álláspontját kifejezni, és a döntéssel szemben kifogást benyújtani.</p>
        <p class="mb-4">Az érintett ügyfél jogosult arra, hogy ne terjedjen ki rá az olyan, kizárólag automatizált
            adatkezelésen - ideértve a profilalkotást is - alapuló döntés hatálya, amely rá nézve joghatással járna vagy
            őt hasonlóképpen jelentős mértékben érintené. Fő szabály szerint automatizált döntések nem alapulhatnak a
            személyes adatoknak a 9. cikk (1) bekezdésében említett különleges kategóriáin, kivéve, ha az ügyfél
            kifejezetten hozzájárul vagy erről valamilyen uniós/ tagállami jog rendelkezik.</p>
        <p class="mb-4">Adatkezelő úgy véli, hogy az adatkezelés arányos az elérni kívánt céllal, tiszteletben tartja a
            személyes adatok védelméhez való jog lényeges tartalmát, és az érintett alapvető jogainak és érdekeinek
            biztosítására megfelelő és konkrét intézkedéseket ír elő.</p>
        <p class="mb-4">Adatkezelő automatikus döntéshozatali eljárást nem alkalmaz.</p>
        <p class="mb-4"><strong>7. Alkalmazott sütik</strong></p>
        <p class="mb-4">A süti (angolul: cookie) egy olyan, apró, szöveges információ-csomag, amelyet a Weboldal az
            érintett felhasználó számítógépének, mobil eszközének merevlemezén található kisméretű fájlba továbbít. Ezek
            a honlapok szervere és az internetes böngésző közti kommunikációban vesznek rész, a Felhasználó számítógépén
            rögzülnek és előre meghatározott érvényességi ideig tárolódnak. Egy süti tipikusan annak a számítógépes
            tartománynak tartalmazza a nevét, amelyről a süti érkezett, valamint tartalmazza a süti érvényességi idejét,
            és egy véletlenszerűen létrehozott számot (értéket). A sütik egy része nem tartalmaz személyes
            információkat, és nem alkalmas az egyéni felhasználó azonosítására, egy részük azonban olyan egyéni
            azonosítót tartalmaz - egy titkos, véletlenül generált számsort - amelyet az Ön eszköze tárol, ezzel az Ön
            azonosíthatóságát is biztosítja. Az egyes cookie-k (sütik) működési időtartamát az egyes cookie-k (sütik)
            vonatkozó leírása tartalmazza.</p>
        <p class="mb-4">A Honlapunkon megtalálható sütik vonatkozásában fontos, hogy dinamikusan változnak,
            belépésenként más-más sütiket használunk. Az éppen aktuálisan használt sütik megtalálhatóak a https:// URL
            cím előtti lakat fülre rákattintva, majd cookie fülön belül kiválasztja, azon belül pedig a cookie fülre
            kattintva a legördülő sávban jelennek meg. Önnek itt lehetősége van az egyes sütik eltávolítására vagy
            tiltására is. https://pipacspekseg.hu/pipacs/</p>
        <p class="mb-4"><strong>8. Érintetti jogok</strong></p>
        <p class="mb-4">Az érintettet a fenti adatkezelések kapcsán az alábbi jogok illetik meg:</p>
        <p class="mb-4">Az érintett jogosult ahhoz, hogy hozzáférjen és megismerhesse a gyűjtött személyes adatokat,
            valamint jogosult arra, hogy ésszerű időközönként ezt a jogát az adatkezelés jogszerűségének megállapítása
            érdekében ellenőrizze, így különösen megilletik a következő táblázatban felsorolt jogok, az érintett kérelme
            alapján.</p>
        <p class="mb-4">Érintetti jogok a személyes adatkezelés kapcsán</p>
        <ul class="mb-4">
            <li>Tájékozódáshoz és információhoz való jog</li>
            <li>Személyes adatokhoz való hozzáférés módosítása</li>
            <li>Helyesbítéshez való jog</li>
            <li>Törlés, elfeledéshez való jog</li>
            <li>Adatkezelés korlátozása</li>
            <li>Tiltakozáshoz való jog és panasztételi jog a személyes adatok kezelése kapcsán</li>
        </ul>
        <p class="mb-4">Az Adatkezelő a kérelem benyújtásától számított 30 napon belül írásban tájékoztatást ad az
            érintettnek a kérelemmel kapcsolatban a kezelt adatairól, azok forrásáról, az adatkezelés céljáról,
            jogalapjáról, időtartamáról, továbbá az adattovábbítás jogalapjáról és címzettjéről.</p>
        <p class="mb-4">Amennyiben a kérelem összetettsége vagy egyéb objektív körülmény indokolja, a fenti határidő
            egyszer, legfeljebb 60 nappal meghosszabbítható, melyről Adatkezelő a kérelmezőt írásban értesíti.</p>
        <p class="mb-4">Abban az esetben, ha Adatkezelő a fenti határidőt elmulasztja, az érintett – a döntés
            közlésétől, illetve a határidő utolsó napjától számított 30 napon belül – bírósághoz fordulhat.</p>
        <p class="mb-4">Az érintettet az őt megillető jogok tekintetében alábbi jogosultságok illetik meg:</p>
        <ul class="mb-4">
            <li>tájékoztatást kérhet,</li>
            <li>kérheti az általunk kezelt személyes adataik helyesbítését, módosítását, kiegészítését,</li>
            <li>tiltakozhat az adatkezelés ellen és kérheti adatai törlését, valamint zárolását (a kötelező adatkezelés
                kivételével),
            </li>
            <li>bíróság előtt jogorvoslattal élhet,</li>
            <li>a felügyeleti hatóságnál panaszt tehet, illetve eljárást kezdeményezhet
                https://naih.hu/panaszuegyintezes-rendje.html
            </li>
        </ul>
        <p class="mb-4">A felügyeleti hatóság elérhetősége:</p>
        <p class="mb-4">Nemzeti Adatvédelmi és Információszabadság Hatóság, http://naih.hu, telefonszám: +36 (1)
            391-1400, postacím: 1363 Budapest, Pf.: 9., 1055 Budapest, Falk Miksa utca 9-11., e-mail:
            ugyfelszolgalat@naih.hu).</p>
        <p class="mb-4">Az érintetti jogokat külön tájékoztató tartalmazza, melyet Adatkezelő az érintettek számára
            elérhetővé tesz.</p>
        <p class="mb-4"><strong>9. Adatbiztonsági intézkedések</strong></p>
        <p class="mb-4">Adatkezelő a weboldalon és a személyes adatok kezelése során gondoskodik az általános
            adatvédelmi rendelet (GDPR) szerinti adatbiztonsági intézkedések megtételéről. Ennek keretében az
            elektronikusan tárolt személyes adatok megfelelő védelme érdekében a szükséges technikai és szervezési
            intézkedéseket megteszi.</p>
        <p class="mb-4">Ennek keretében elfogadja és kialakítja napra készen tartja, illetve rendszeresen felülvizsgálja
            mindazokat a technikai és szervezési intézkedéseket, eljárási szabályokat, amelyek biztosítják, hogy az
            általa kezelt személyes adatok biztonsága biztosított legyen, és megtesz minden tőle elvárhatót annak
            érdekében, hogy megakadályozza a személyes adatok megsemmisülését, jogosulatlan felhasználását vagy
            megváltoztatását, valamint gondoskodik arról, hogy a kezelt személyes adatokhoz illetéktelen személy ne
            férhessen hozzá, azokat ne hozhassa nyilvánosságra, ne továbbíthassa, valamint ne módosíthassa,
            törölhesse.</p>
        <p class="mb-4">Az Adatkezelő az adatbiztonság érvényesülése tekintetében az érintettek részére a szükséges
            tájékoztatást megadja, annak érdekében, hogy a szükséges adatvédelmi ismeretek birtokában legyenek, és
            gondoskodik arról, hogy megbízottjai, alkalmazottai intézkedéseik során az adatbiztonság követelményeit
            betartva járjanak el.</p>
        <p class="mb-4">Adatkezelő a tudomány és technika fejlődését folyamatosan figyelemmel kíséri, annak érdekében,
            az elérhető műszaki, technológiai, szervezési megoldásokat, valamint az adatkezelései által indokolt védelmi
            szintnek megfelelő megoldásokat alkalmazza.</p>
        <p class="mb-4">Az adatvédelmi incidensek megelőzése és kezelése érdekében az Adatkezelő adatvédelmi tudatosság
            növelő intézkedéseket hoz, melyek betartását ellenőrzi.</p>
        <p class="mb-4">Az informatikai rendszerek működtetése során az Adatkezelő a szükséges jogosultságkezelési,
            belső szervezési és technikai megoldások segítségével biztosítja, hogy az érintettek személyes adatai
            illetéktelen személyek birtokába ne juthassanak, illetéktelen személyek az adatokat ne tudják törölni,
            kimenteni a rendszerből, vagy módosítani.</p>
        <p class="mb-8">Adatkezelő Incidenskezelési Szabályzattal rendelkezik, illetve az esetleges adatvédelmi
            incidensekről Incidens Nyilvántartást vezet, amennyiben szükséges, a felmerülő incidensekről tájékoztatja az
            érintettet.</p>
        <p class="mb-4">Budapest, 2025.07.16.</p>
    </div>
</template>
<script setup lang="ts">
</script>